import { useEffect, useState, useRef } from 'react'
import { produce } from 'immer'
import Popover from '@/components/Popover'
import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import classname from 'classnames'
import ClickMultiCheck from '@/utils/click-multicheck'

export function UpdatedFunction(items, index) {
    return produce(items, draft => {
        if (draft[index]) {
            draft[index].$selected = !draft[index].$selected
        }
    })
}

export function changeAllListCheckboxes(event, items, onChangeFunc) {
    if (event.target.checked) {
        const updatedItemCheckbox = items?.map(field => ({ ...field, $selected: true }))
        items = updatedItemCheckbox
        return onChangeFunc(updatedItemCheckbox)
    }

    items = items?.map(field => ({ ...field, $selected: false }))
    return onChangeFunc(items)
}

const MultiSelectCheckbox2 = ({ items, onChangeFunc }) => {
    const placeholder = "All (Default)"

    /*=================================================
        Filter Popup
    /================================================*/
    const [filterVisible, setMultiFilterVisible] = useState(false)
    const referenceRef = useRef(null)

    const classForLabel = classname({
        "card-configure__group__content__container": true,
    })

    const classForLabelActive = classname({
        "card-configure__group__content__container": true,
        "card-configure__group__content__container-label": true
    })

    const count = items?.filter(item => item.$selected === true).length;

    useEffect(() => {
        const clickMultiCheckCb = (e) => ClickMultiCheck(referenceRef, setMultiFilterVisible, e);
		document.addEventListener('mousedown', clickMultiCheckCb)
		return () => {
			document.removeEventListener('mousedown', clickMultiCheckCb)
		}
	}, [filterVisible])

    function isMultiAllChecked() {
        return items?.every(field => field.$selected)
    }

    function changeListCheckboxes(event) {
        const index = items?.findIndex((field) => field.id === event.target.value)
        const updatedItem = UpdatedFunction(items, index)
        items = updatedItem
        onChangeFunc(updatedItem)
    }

    const list = items?.map((field, index) => {
        return (
            <div className="card-configure__group__content__col card-configure__group__content__padding" key={index}>
                <label htmlFor={field.id} className={field.$selected ? classForLabel : classForLabelActive}>{field.label}
                    <input type="checkbox" name={field.label}
                        value={field.id}
                        id={field.id}
                        checked={field.$selected}
                        onChange={(e) => changeListCheckboxes(e)} />
                    <span className="card-configure__group__content__checkmark"></span>
                </label>
            </div>
        )
    })

    return (
        <div className="multiCheckboxSelect__group">
            <Popover visible={filterVisible}
                options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
            >
                <Popover.Trigger>
                    <div id="trigger-visiblity" className="multiCheckboxSelect__trigger multiCheckboxSelect__class" onClick={() => {
                        setMultiFilterVisible(!filterVisible)
                    }}>
                        {
                            (count > 0) && (count < items?.length) && (
                                <span className="multiCheckboxSelect__selected multiCheckboxSelect__selected-margin">
                                    {count + " Selected"}
                                </span>
                            )
                        }
                        {
                            items?.length > 0 && (count === items?.length) && (
                                <span className="multiCheckboxSelect__selected-empty">
                                    All (Default)
                                </span>
                            )
                        }
                        {
                            (count === 0) && (
                                <span className="multiCheckboxSelect__selected-empty">
                                    {placeholder}
                                </span>
                            )
                        }
                        <IconChevronDown />
                    </div>
                </Popover.Trigger>

                <Popover.Content>
                    <div className="multiCheckboxSelect2__content" ref={referenceRef} >
                        <div className="multiCheckboxSelect__group__content">
                            <div className="multiCheckboxSelect__group__content__cols">
                                {
                                    list?.length > 0 && (
                                        <>
                                            <div className="card-configure__group__content__col card-configure__group__content__padding">
                                                <label htmlFor="All" className={isMultiAllChecked() ? classForLabel : classForLabelActive}>All (Default)
                                                    <input type="checkbox" id="All" checked={isMultiAllChecked()}
                                                        onChange={(e) => changeAllListCheckboxes(e, items, onChangeFunc)} />
                                                    <span className="card-configure__group__content__checkmark"></span>
                                                </label>
                                            </div>
                                            {list}
                                        </>
                                    )
                                }
                                {
                                    list?.length === 0 && (
                                        <div className="card-configure__group__content__col">
                                            No Data Element Found
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </Popover.Content>
            </Popover>
        </div>

    )
}

export default MultiSelectCheckbox2
